import React, { Component } from "react";
import { Localization } from "../common/Localization";
import NasnimanyCiarovyKod from "../common/SnimanieCiarovehoKodu/NasnimanyCiarovyKod";
import LoadingPanel from "../common/LoadingPanel";
import { registerForLocalization, provideLocalizationService } from "@progress/kendo-react-intl";
import { Form, Field } from "react-final-form";
import { Input, NumericTextBox } from "@progress/kendo-react-inputs";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Button, DropDownButton, DropDownButtonItem } from "@progress/kendo-react-buttons";
import TovarFoto from "../common/TovarFoto";
import { balikArtikleController } from "../../controllers/balikartikle.controller";
import { OnChange } from "react-final-form-listeners";
import KeyboardEventHandler from "react-keyboard-event-handler";
import GetArtikelFromCiarovyKod from "../common/SnimanieCiarovehoKodu/GetArtikelFromCiarovyKod";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { Zvuky } from "../common/Zvuky";
import confirmService from "../common/confirmService";
import { MessageTypeEnum, ButtonGroupEnum, ButtonMessageEnum, CiarovyKodAllowedHandleKeys, TypTovaru } from "../../enums";
import { animateScroll as scroll } from "react-scroll";
import { authenticationService } from "../../services/authentication.service";
import { kodFarbyCell } from "../common/Helpers";

const formValidation = (values) => {
    const errors = {};

    if (!values.typTovaruKodItem) {
        errors.typTovaruKodItem = "Typ tovaru je povinná položka.";
    }
    if (!values.skladToItem || values.skladToItem.id === 0) {
        errors.skladToItem = "Príjemca je povinná položka.";
    }

    return errors;
};

const kendoHOC = (type, { input, meta, label, ...rest }) => {
    const Type = type;
    const LabelElement = type !== DropDownList ? "label" : "span";
    if (type === NumericTextBox && input.value === "") {
        input.value = null;
    }
    return (
        <LabelElement className="k-form-field">
            <span>{label}</span>
            <Type {...input} {...rest} />
            {meta.error && meta.touched && <span className="k-required">{meta.error}</span>}
        </LabelElement>
    );
};
const KendoInput = (options) => kendoHOC(Input, options);
const KendoDropDown = (options) => kendoHOC(DropDownList, options);

class BalikArtikleDialogContent extends Component {
    state = {
        idBalik: null,
        balik: null,
        selectedId: null,
        selectedIdVariant: null,
        loading: true,
        availableSkladItems: [],
        typTovaruKodItemOpened: false,
        skladToItemOpened: false,
        skenProgress: false
    };

    async prekroceniVahyBalikaDialog() {
        const confirmResult = await confirmService.show({
            type: MessageTypeEnum.QUESTION,
            message:
                "Balík je príliš ťažký: " +
                this.state.balik.vaha.toFixed(1) +
                " kg !\r\nKvoli bezpečnej a bezproblémovej manipulácii váha balíka nesmie presiahnuť 15 kg.\r\nChcete pokračovať v ukladaní balíka ?",
            buttons: ButtonGroupEnum.YES_NO,
            width: "600px",
            logMessage: true
        });
        if (confirmResult == ButtonMessageEnum.YES) {
            this.confirmNadmernaVaha();
        }
    }

    async opakovaneUlozenieBalikaDialog() {
        const confirmResult = await confirmService.show({
            type: MessageTypeEnum.EXCLAMATION,
            message:
                "Chystáte sa uložiť zmeny v balíku " +
                this.state.balik.kodBalika +
                " a vytlačiť nový štítok !\r\nStarý štítok k balíku " +
                this.state.balik.kodBalika +
                " zničte !",
            buttons: ButtonGroupEnum.OK_CANCEL,
            logMessage: true
        });
        if (confirmResult == ButtonMessageEnum.OK) {
            return true;
        }
        return false;
    }

    async odstraneniVsechArtiklovDialog() {
        const confirmResult = await confirmService.show({
            type: MessageTypeEnum.QUESTION,
            message: "Chcete vymazať zoznam artiklov ?",
            buttons: ButtonGroupEnum.YES_NO,
            logMessage: true
        });
        if (confirmResult == ButtonMessageEnum.YES) {
            this.odstranitVsechnyArtikle();
        }
    }

    componentDidMount() {
        var localizationService = provideLocalizationService(this);

        balikArtikleController.getForCreateEdit(this.props.idBalik).then((response) => {
            if (response.errorMessage) {
                this.setState({
                    idBalik: response.idbalik,
                    balik: response,
                    loading: false
                });
            } else {
                response.typTovaruItems.forEach((item) => {
                    item.name = localizationService.toLanguageString(item.messageKey, item.name);
                });

                response = {
                    typTovaruKodItem: this.getDefaultItem(response.typTovaruItems, response.typTovaruKod),
                    skladToItem: this.getDefaultItem(response.skladItems, response.skladTo),
                    ...response
                };

                this.setState({
                    idBalik: response.idbalik,
                    balik: response,
                    loading: false
                });

                var isBalikEdited = this.state.balik.typTovaruKodItem;
                if (isBalikEdited) {
                    var skladItemsOptions = this.getAvailableSkladItems(this.state.balik.typTovaruKodItem.id);
                    this.setState({
                        availableSkladItems: skladItemsOptions,
                        selectedSkladItem: skladItemsOptions.lenth > 1 ? this.state.balik.defaultSkladItem : skladItemsOptions[0]
                    });
                }

                if (this.state.idBalik == 0) {
                    var autoFocus = document.getElementsByName("typTovaruKodItem")[0];
                    if (autoFocus) {
                        autoFocus.focus();
                        this.setState({ typTovaruKodItemOpened: true });
                    }
                } else {
                    this.focusSubmitButton();
                }
            }
        });
    }

    focusSubmitButton() {
        var dialogContent = document.getElementsByClassName("k-content k-window-content k-dialog-content")[0];
        if (dialogContent) {
            var autoFocus = dialogContent.getElementsByClassName("auto-focus")[0];
            if (autoFocus) {
                autoFocus.focus();
            }
        }
    }

    focusAndOpenSkladToItem(skladItemsOptions) {
        if (skladItemsOptions.length > 1) {
            var autoFocus = document.getElementsByName("skladToItem")[0];
            if (autoFocus) {
                autoFocus.focus();
            }

            this.setState({
                skladToItemOpened: true
            });
        }
    }

    getDefaultItem(items, selectedId) {
        var result;
        items.forEach((item) => {
            if (item.id === selectedId) {
                result = item;
            }
        });

        return result;
    }

    /**
     * Metoda, která je volána při odeslání formuláře.
     *
     * @memberof BalikArtikleDialogContent
     */
    async onSubmit() {
        var localizationService = provideLocalizationService(this);

        const confirmResult = await confirmService.show({
            type: MessageTypeEnum.QUESTION,
            message: localizationService.toLanguageString(
                "BalíkFRM.Chcete uložiť balík a vytlačiť štítok a dodací list ?",
                "Chcete uložiť balík a vytlačiť štítok a dodací list ?"
            ),
            buttons: ButtonGroupEnum.OK_CANCEL,
            logMessage: true
        });
        if (confirmResult == ButtonMessageEnum.OK) {
            await this.confirmSaveBalik();
        }
    }

    /**
     * Uložení balíku.
     *
     * @memberof BalikArtikleDialogContent
     */
    saveBalik() {
        var dialog = document.getElementById("BalikArtikleDialog");
        var button = dialog.getElementsByClassName("save-button")[0];
        button.disabled = true;
        this.setState({
            skenProgress: true
        });
        balikArtikleController.SaveBalik(this.state.balik).then(async (response) => {
            this.setState({
                skenProgress: false
            });
            if (response.errorMessage) {
                button.disabled = false;
                await confirmService.show({
                    type: response.messageType,
                    message: response.errorMessage,
                    logMessage: true
                });
                return false;
            } else {
                this.props.toggleDialog();
                this.props.reloadGrid(() => {
                    if (response.balikId > 0) {
                        this.props.printBalikStitek(response.balikId);
                        if (this.props.selectSavedBalikPaleta) {
                            setTimeout(() => this.props.selectSavedBalikPaleta(response.balikId), 500);
                        }
                    }
                });
                return true;
            }
        });
    }

    async validateVaha() {
        if (this.state.balik.vaha > 15) {
            await this.prekroceniVahyBalikaDialog();
            return false;
        }
        return true;
    }

    getAvailableSkladItems(typTovaruId) {
        switch (typTovaruId) {
            case TypTovaru.P1:
                return this.state.balik.skladItems.filter((el) => {
                    return el.idkrajina === 1 && el.typSkladu === 2 && el.id !== authenticationService.currentSklad;
                });
            case TypTovaru.P2:
                return this.state.balik.skladItems.filter((el) => {
                    return el.idkrajina === 2 && el.typSkladu === 2 && el.id !== authenticationService.currentSklad;
                });
            case TypTovaru.P3:
                return this.state.balik.skladItems.filter((el) => {
                    return el.idkrajina === 3 && el.typSkladu === 2 && el.id !== authenticationService.currentSklad;
                });
            case TypTovaru.PE:
                return this.state.balik.skladItems.filter((el) => {
                    return el.id === 90; // Eshop
                });
            case TypTovaru.V:
            case TypTovaru.ZR:
            case TypTovaru.SR:
                return this.state.balik.skladItems.filter((el) => {
                    return el.id === 1;
                });
            default:
                return this.state.balik.skladItems.filter((el) => {
                    return el.id === 0 && el.id !== 0;
                });
        }
    }

    handleTypTovaruChange = (event) => {
        var balik = this.state.balik;
        balik.typTovaru = event.id;
        balik.typTovaruKod = event.id;
        balik.idvlna = -1;
        balik.vlnaNazov = "";
        var skladItemsOptions = this.getAvailableSkladItems(event.id);
        if (skladItemsOptions.length > 1) {
            skladItemsOptions.unshift(this.state.balik.defaultSkladItem);
        }

        this.setState({
            availableSkladItems: skladItemsOptions,
            selectedSkladItem: skladItemsOptions[0],
            balik: balik
        });
        this.props.balikIsChanged();
        this.focusAndOpenSkladToItem(skladItemsOptions);

        return skladItemsOptions[0];
    };

    handleKeyEvent(key, e) {
        this.setState({
            keyboardEvent: e
        });
        e.preventDefault();
        return false;
    }

    async handleTestKeyEvent(key, e) {
        switch (key) {
            case "shift+a":
                // A - náhodně vybraný čárový kód
                var balik = this.state.balik;
                var response = await balikArtikleController.TEMP_GetArtikel(balik);
                if (response.isError) {
                    Zvuky.playChyba();
                    await confirmService.show({
                        message: response.errorMessage,
                        logMessage: true
                    });
                    return;
                }
                await this.GetNewArtikel(response);
                break;
        }
        e.preventDefault();
        return false;
    }

    SetSkenProgress = async () => {
        if (this.state.skenProgress) {
            await Zvuky.playChyba();
            return false;
        }
        this.setState({
            skenProgress: true
        });
        return true;
    };

    GetNewArtikel = async (response) => {
        if (response.isError) {
            Zvuky.playChyba();
            this.setState({
                skenProgress: false
            });
            this.props.showErrorDialog(response.errorMessage);
            return;
        }
        var balik = this.state.balik;
        balik.artikle = response.balik.artikle;
        balik.pocetKs = response.balik.pocetKs;
        balik.vaha = response.balik.vaha;
        balik.poleVlnaArt = response.balik.poleVlnaArt;
        balik.idvlna = response.balik.idvlna;
        balik.vlnaNazov = response.balik.vlnaNazov;

        var latestArtikel = this.getLatestArtikel(balik.artikle);
        balik.typBalika = response.balik.typBalika;
        this.setState({
            balik: balik,
            selectedId: latestArtikel.selectedArtikelId,
            selectedIdVariant: latestArtikel.selectedArtikelIdVariant,
            skenProgress: false
        });

        this.scrollToBottom();
        this.props.balikIsChanged();

        this.setVahaColor(balik.vaha);

        await Zvuky.playOk();
    };

    setVahaColor(vaha) {
        if (vaha > 15) {
            document.getElementById("inputVaha").style.backgroundColor = "#FF0000";
        } else if (vaha > 14) {
            document.getElementById("inputVaha").style.backgroundColor = "#FFFF00";
        } else {
            document.getElementById("inputVaha").style.backgroundColor = "#FFFFFF";
        }
    }

    scrollToBottom() {
        var divDialog = document.getElementById("BalikArtikleDialog");
        if (divDialog) {
            var container = divDialog.getElementsByClassName("k-virtual-content");
            if (container) {
                scroll.scrollToBottom({
                    container: container[0]
                });
            }
        }
    }

    getLatestArtikel(balikArtikle) {
        if (balikArtikle.length > 0) {
            var lastElement = [...balikArtikle].pop();
            return {
                selectedArtikelId: lastElement.id,
                selectedArtikelIdVariant: lastElement.idvariant
            };
        }
        return {};
    }

    handleMoznostiItemClick(event) {
        switch (event.itemIndex) {
            case 0:
                if (this.state.balik.artikle.length > 0) {
                    this.odstraneniVsechArtiklovDialog();
                }
                break;
            case 1:
                this.vratenieTovaruMimoVln();
                break;
        }
    }

    async vratenieTovaruMimoVln() {
        if (this.state.balik.typTovaru !== TypTovaru.V) {
            await confirmService.show({
                type: MessageTypeEnum.EXCLAMATION,
                message: "Táto funkcia je platná len pre vrátenie tovaru !",
                logMessage: true
            });
        } else {
            var balik = this.state.balik;
            balik.idvlna = 0;
            var response = await balikArtikleController.VratenieTovaruMimoVln(balik);
            if (response.isError) {
                Zvuky.playChyba();
                await confirmService.show({
                    message: response.errorMessage,
                    logMessage: true
                });
                return;
            }
            balik.idvlna = response.balik.idvlna;
            balik.vlnaNazov = response.balik.vlnaNazov;
            this.setState({
                balik: balik
            });
        }
    }

    odstranitVsechnyArtikle = () => {
        var balik = this.state.balik;
        balik.artikle = [];
        balik.pocetKs = 0;
        balik.vaha = 0;
        balik.idvlna = -1;
        balik.vlnaNazov = "";
        this.setState({
            balik: balik,
            selectedId: null,
            selectedIdVariant: null
        });
        this.setVahaColor(balik.vaha);
        this.props.balikIsChanged();
    };

    handleOdstranitArtikel() {
        var balik = this.state.balik;
        var idToRemove = this.state.selectedId;
        balik.artikle = balik.artikle.filter(function (value) {
            return value.id != idToRemove;
        });
        balik.vaha = balik.artikle.reduce(function (accumulator, currentValue) {
            return accumulator + currentValue.vaha;
        }, 0);
        balik.pocetKs = balik.artikle.length;
        if (balik.pocetKs == 0) {
            balik.idvlna = -1;
            balik.vlnaNazov = "";
        }
        this.setState({
            balik: balik,
            selectedId: balik.pocetKs > 0 ? this.state.selectedId : null,
            selectedIdVariant: balik.pocetKs > 0 ? this.state.selectedIdVariant : null
        });
        this.setVahaColor(balik.vaha);
        this.props.balikIsChanged();
    }

    removeArtikelById(value) {
        return value.id != this.state.selectedId;
    }

    async componentWillReceiveProps(nextProps) {
        if (nextProps.showClosingConfirmDialog) {
            var localizationService = provideLocalizationService(this);

            const confirmResult = await confirmService.show({
                type: MessageTypeEnum.QUESTION,
                message: localizationService.toLanguageString(
                    "BalíkFRM.Chcete uložiť zmeny v balíku a vytlačiť štítok a dodací list ?",
                    "Chcete uložiť zmeny v balíku a vytlačiť štítok a dodací list ?"
                ),
                buttons: ButtonGroupEnum.YES_NO_CANCEL,
                logMessage: true
            });
            if (confirmResult == ButtonMessageEnum.YES) {
                await this.confirmSaveBalik();
            } else if (confirmResult == ButtonMessageEnum.NO) {
                this.closeDialog();
            } else {
                this.props.closeConfirmDialog();
            }
        }
    }

    async confirmSaveBalik() {
        if (!(await this.validateVaha())) {
            return false;
        }
        if (this.state.balik.idbalik > 0 && !(await this.opakovaneUlozenieBalikaDialog())) {
            return false;
        }
        this.props.closeConfirmDialog();
        if (this.saveBalik()) {
            this.props.toggleDialog(true);
        }
    }

    confirmNadmernaVaha = () => {
        if (this.saveBalik()) {
            this.props.toggleDialog(true);
        }
    };

    closeDialog = () => {
        this.props.toggleDialog(true);
    };

    textArtikelCell = (props) => {
        return (
            <td onClick={() => this.onRowClick(props)}>
                <div style={{ color: "grey" }} dangerouslySetInnerHTML={{ __html: props.dataItem.cisloArtikel }}></div>
                <div style={{ fontSize: "1.4em" }} dangerouslySetInnerHTML={{ __html: props.dataItem.textArtikel }}></div>
            </td>
        );
    };

    textVelkostCell = (props) => {
        return (
            <td className="velkost-cell" onClick={() => this.onRowClick(props)}>
                {props.dataItem.textVelkost}
            </td>
        );
    };

    textCenaCell = (props) => {
        return (
            <td className="cena-container" onClick={() => this.onRowClick(props)}>
                <div className="cena-cell">
                    <div style={{ color: "grey" }}>{props.dataItem.textCena1 ? props.dataItem.textCena : ""}</div>
                    <div style={{ fontSize: "1.4em" }} dangerouslySetInnerHTML={{ __html: props.dataItem.textCenaZobr }}></div>
                </div>
                <div className="mena-cell">{props.dataItem.textMena}</div>
            </td>
        );
    };

    onRowClick = (e) => {
        this.setState({ selectedId: e.dataItem.id, selectedIdVariant: e.dataItem.idvariant });
    };

    renderDialogContent() {
        var localizationService = provideLocalizationService(this);

        return this.state.balik.isError ? (
            <div className="alert alert-danger">{this.state.balik.errorMessage}</div>
        ) : (
            <div id="BalikArtikleDialog">
                <KeyboardEventHandler
                    handleKeys={CiarovyKodAllowedHandleKeys}
                    onKeyEvent={(key, e) => this.handleKeyEvent(key, e)}
                    // isExclusive={true}
                    handleFocusableElements={true}
                />
                <NasnimanyCiarovyKod keyboardEvent={this.state.keyboardEvent}>
                    <GetArtikelFromCiarovyKod balik={this.state.balik} startRequest={this.SetSkenProgress} skenProgress={this.state.skenProgress} getArtikel={this.GetNewArtikel} />
                </NasnimanyCiarovyKod>
                <KeyboardEventHandler handleKeys={["shift+a"]} onKeyEvent={(key, e) => this.handleTestKeyEvent(key, e)} handleFocusableElements={true} />
                <Form
                    validate={formValidation}
                    onSubmit={async () => await this.onSubmit()}
                    initialValues={this.state.balik}
                    render={({ form, handleSubmit }) => (
                        <React.Fragment>
                            <form id="BalikArtikleForm" onSubmit={handleSubmit} className="k-form">
                                <OnChange name="typTovaruKodItem">
                                    {(value) => {
                                        form.change("typTovaruKodItem", value);
                                        form.change("skladToItem", this.handleTypTovaruChange(value));
                                    }}
                                </OnChange>
                                <OnChange name="skladToItem">
                                    {(value) => {
                                        form.change("skladToItem", value);
                                        var balik = this.state.balik;
                                        balik.skladToItem = value;
                                        this.setState({
                                            balik: balik
                                        });
                                        if (value && value.id > 0) this.focusSubmitButton();
                                    }}
                                </OnChange>
                                <fieldset>
                                    <div className="row">
                                        <div className="col-xs-7">
                                            <Field
                                                name="kodBalika"
                                                label={localizationService.toLanguageString("BalíkFRM.BALÍK", "BALÍK")}
                                                component={KendoInput}
                                                className="kod-balika-input"
                                                disabled
                                            />
                                            <Field
                                                name="skladFromNazov"
                                                label={localizationService.toLanguageString("BalíkFRM.ODOSIELATEĽ", "ODOSIELATEĽ")}
                                                component={KendoInput}
                                                disabled
                                            />
                                            <Field
                                                name="ciarovyKod"
                                                label={localizationService.toLanguageString("BalíkFRM.ČIAROVÝ KÓD", "ČIAROVÝ KÓD")}
                                                component={KendoInput}
                                                disabled
                                            />
                                        </div>
                                        <div className="col-xs-5">
                                            <Field
                                                name="typTovaruKodItem"
                                                component={KendoDropDown}
                                                data={this.state.balik.typTovaruItems}
                                                opened={this.state.typTovaruKodItemOpened}
                                                onOpen={() => this.setState({ typTovaruKodItemOpened: true })}
                                                onClose={() => this.setState({ typTovaruKodItemOpened: false })}
                                                textField="name"
                                                dataItemKey="id"
                                                label={localizationService.toLanguageString("BalíkFRM.TYP TOVARU", "TYP TOVARU")}
                                                disabled={
                                                    (this.state.idBalik == 0 && this.state.balik.pocetKs > 0) ||
                                                    (this.state.idBalik > 0 && this.state.balik.typTovaru != TypTovaru.V)
                                                }
                                            />
                                            <Field
                                                name="skladToItem"
                                                component={KendoDropDown}
                                                data={this.state.availableSkladItems}
                                                opened={this.state.skladToItemOpened}
                                                onOpen={() => this.setState({ skladToItemOpened: true })}
                                                onClose={() => this.setState({ skladToItemOpened: false })}
                                                textField="nazov"
                                                dataItemKey="id"
                                                label={localizationService.toLanguageString("BalíkFRM.PRÍJEMCA", "PRÍJEMCA")}
                                            />
                                            <div className="row">
                                                <div className="col-xs-4">
                                                    <div className="k-form-field">
                                                        <span>{localizationService.toLanguageString("BalíkFRM.POČET KS", "POČET KS")}</span>
                                                        <Input value={this.state.balik.pocetKs} disabled />
                                                    </div>
                                                </div>
                                                <div className="col-xs-4">
                                                    <div className="k-form-field">
                                                        <span>{localizationService.toLanguageString("BalíkFRM.VÁHA", "VÁHA")}</span>
                                                        <Input id="inputVaha" value={this.state.balik.vaha.toFixed(1) + " kg"} disabled />
                                                    </div>
                                                </div>
                                                <div className="col-xs-4">
                                                    <div className="k-form-field">
                                                        <span>&nbsp;</span>
                                                        <Input value={this.state.balik.vlnaNazov} disabled />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>
                            </form>
                            <div className="row">
                                <div className="col-xs-7">
                                    <Grid
                                        data={
                                            this.state.balik.artikle === null
                                                ? []
                                                : this.state.balik.artikle.map((item) => ({
                                                      ...item,
                                                      selected: item.id === this.state.selectedId
                                                  }))
                                        }
                                        selectedField="selected"
                                        onRowClick={this.onRowClick}
                                        className="BalikArtikleGrid">
                                        <GridColumn
                                            cell={this.textArtikelCell}
                                            title={localizationService.toLanguageString("BalíkFRM.Artikle v balíku", "Artikle v balíku")}
                                        />
                                        <GridColumn cell={kodFarbyCell} title={localizationService.toLanguageString("DLREP.Farba", "Farba")} width="30px" />
                                        <GridColumn
                                            cell={this.textVelkostCell}
                                            title={localizationService.toLanguageString("DLREP.Veľkosť", "Veľkosť")}
                                            width="60px"
                                        />
                                        <GridColumn cell={this.textCenaCell} title={localizationService.toLanguageString("DLREP.Cena", "Cena")} width="100px" />
                                    </Grid>
                                    {this.state.skenProgress ? <LoadingPanel /> : <React.Fragment></React.Fragment>}
                                </div>
                                <div className="col-xs-5">
                                    {this.state.selectedIdVariant ? <TovarFoto idVariant={this.state.selectedIdVariant} /> : <React.Fragment></React.Fragment>}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xs-5 button-bar">
                                    <Button icon="minus" onClick={(e) => this.handleOdstranitArtikel(e)} disabled={this.state.selectedId == null}>
                                        <Localization messageKey={"BalíkFRM.Odstrániť artikel z balíka"} defaultMessage={"Odstrániť artikel z balíka"} />
                                    </Button>
                                </div>
                                <div className="col-xs-2 button-bar">
                                    <DropDownButton
                                        text={localizationService.toLanguageString("MenuFRM.Možnosti", "Možnosti")}
                                        icon="menu"
                                        onItemClick={(e) => this.handleMoznostiItemClick(e)}>
                                        <DropDownButtonItem
                                            text={localizationService.toLanguageString(
                                                "MenuFRM.Zmazať všetky artikle v balíku",
                                                "Zmazať všetky artikle v balíku"
                                            )}
                                        />
                                        <DropDownButtonItem
                                            text={localizationService.toLanguageString("MenuFRM.Vrátenie tovaru mimo vĺn", "Vrátenie tovaru mimo vĺn")}
                                        />
                                    </DropDownButton>
                                </div>
                                <div className="col-xs-5 button-bar text-right">
                                    <Button icon="save" onClick={handleSubmit} className="auto-focus save-button">
                                        <Localization
                                            messageKey={"BalíkFRM.Uložiť balík a vytlačiť štítok a dodací list"}
                                            defaultMessage={"Uložiť balík a vytlačiť štítok a dodací list"}
                                        />
                                    </Button>
                                </div>
                            </div>
                        </React.Fragment>
                    )}
                />
            </div>
        );
    }

    render() {
        let contents = this.state.loading ? <LoadingPanel /> : this.renderDialogContent();

        return <div>{contents}</div>;
    }
}

export default BalikArtikleDialogContent;

registerForLocalization(BalikArtikleDialogContent);



// WEBPACK FOOTER //
// ./src/components/dialogs/BalikArtikleDialogContent.js